export const WILDCARD_OPERATION = '$$WILDCARD_OPERATION';
